import { getElementTag } from '../../lib/get-element-tag.ts'
import { config } from './config.ts'
import '@nrk/core-design-tokens/dist/color/nrk-color-tokens.css'
import '../../common/melding/melding.module.css'
import './meldinger.module.css'

const tag = getElementTag(__APP_NAME__, config.moduleName, __APP_VERSION__)

class AppElement extends HTMLElement {
  connectedCallback() {}
}

if (customElements.get(tag) === undefined) {
  customElements.define(tag, AppElement)
}
